<kodit-table [tableConfig]="tableConfig" [items]="items" [chipItems]="chipItems"></kodit-table>
